import { call, put, takeLatest } from "redux-saga/effects";
import { loginApi, verifyOtpApi, logoutApi } from "../../utils/auth.api";
import { buildLogoutPayload } from "../../utils/jwt";
import { clearSession } from "../../utils/session";

function* loginSaga(action: any): any {
    try {
        const res = yield call(loginApi, action.payload);
        //console.log("LOGIN API RESPONSE:", res.data);

        if (res.data.status && res.data.status !== 200) {
            yield put({
                type: "LOGIN_FAILURE",
                payload: res.data.message || "Login failed",
            });
            return;
        }

        yield put({
            type: "LOGIN_SUCCESS",
            payload: { username: action.payload.username },
        });
    } catch (error: any) {
        yield put({
            type: "LOGIN_FAILURE",
            payload: error.response?.data?.message || "Login failed",
        });
    }
}

function* verifyOtpSaga(action: any): any {
    try {
        const res = yield call(verifyOtpApi, action.payload);

        if (res.data.token) {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("username", action.payload.username);
        }

        yield put({ type: "VERIFY_OTP_SUCCESS", payload: res.data });

    } catch (error: any) {
        yield put({
            type: "VERIFY_OTP_FAILURE",
            payload: error.response?.data?.message || "OTP failed",
        });
    }
}

function* logoutSaga(action: any): any {
    try {
        const token = action?.payload?.token || localStorage.getItem("token");
        const username = action?.payload?.username || localStorage.getItem("username") || "";
        const roleid = action?.payload?.roleid || localStorage.getItem("roleid") || "";
        if (token) {
            yield call(logoutApi, buildLogoutPayload(token, { username, roleid }));
        }
    } catch (e) {
        //console.error("Logout API failed:", e);
    } finally {
        clearSession();
        yield put({ type: "LOGOUT" });
    }
}

export default function* authSaga() {
    yield takeLatest("LOGIN_REQUEST", loginSaga);
    yield takeLatest("VERIFY_OTP_REQUEST", verifyOtpSaga);
    yield takeLatest("LOGOUT_REQUEST", logoutSaga);
}